/**
 * ENSender module
 *
 * Send wrapper for AJAX requests to Engaging Networks
 *
 * @version  0.2
 * @requires jQuery
 */
var requiredOptions = [ ];

//assumed defaults for sending to EN
var defaults = {
    type: 'GET',
    crossDomain: true,
    dataType: 'jsonp',
    url: '//e-activist.com/ea-action/action?format=json',
    data: [ ],
    success: function() { },
    error: function() { }
};

var protect = {
};

var grHelpers = require('./GRHelpers');

/**
 * ENSender Constructor
 * @param {Object} opts collection of options to override the default
 * @since 0.2 - switched options variable to be part of the instance rather than global within the module
 */
  function ENSender(opts) {
    if((missing = grHelpers.hasMissingOptions(opts, requiredOptions))) {
      throw new Error("[ENSender] Missing required options: " + missing.join(', '));
    }
    else {
      this.options = $.extend(true, {}, defaults, opts, protect);
      //this.init();
    }
  }

  /**
  * Sends and receives data from the site
  * @param Object opts a list of options that should be used on this specific send, values that aren't present will be replaced with the ones in the global varibale options (set when instantiating this module)
  * Expected keys are:
  *   type: {string}
  *   crossDomain: {bool}
  *   dataType: {string}
  *   url: {string}
  *   data: {Array, Object, or string}
  *   success: {function(data, status, xhr)}
  *   error: {function(xhr, status, errorThrown)}
  *   form: {jQuery Object} [optional, but if present will receive triggered custom events]
  **/
  ENSender.prototype.send = function( opts ){
    if(typeof opts == "undefined") opts = { };
    var sendParameters = $.extend(true, {}, this.options, opts);

    $.ajax({
      type: sendParameters.type,
      url: sendParameters.url,
      data: sendParameters.data,
      dataType: sendParameters.dataType,
      crossDomain: sendParameters.crossDomain,
      error: function(xhr, status, errorThrown) {
        if(typeof sendParameters.form != "undefined")
          sendParameters.form.trigger('send.failed.ENSender', [xhr, status, errorThrown]);
        sendParameters.error(xhr, status, errorThrown);
      },
      success: function(data, status, xhr) {
        if(typeof data.messages != "undefined" && data.messages.length && typeof sendParameters.form != "undefined") {
          sendParameters.form.trigger('enresponse.error.ENSender', [data]);
        }
        sendParameters.success(data, status, xhr);
      }
    });

  }

  module.exports = ENSender;
